// extracted by mini-css-extract-plugin
export var errorIcon = "_jd-1";
export var nameLogo = "_jd-0";